import { render, staticRenderFns } from "./ConcernFormModal.vue?vue&type=template&id=05685146&scoped=true&"
import script from "./ConcernFormModal.vue?vue&type=script&lang=js&"
export * from "./ConcernFormModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05685146",
  null
  
)

export default component.exports